const CircleReloadIcon = ({ className }) => {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect x="0.5" width="48" height="48" rx="24" fill="#E6EEFF" />
      <path
        d="M28.4521 12.7675C28.1977 12.2906 27.6062 12.1109 27.1308 12.366C26.8752 12.5031 26.7572 12.736 26.6422 13L26.1188 14.1182C25.5911 14.0364 25.0504 13.994 24.5 13.994C18.8669 13.994 14.25 18.4464 14.25 24C14.25 25.8268 14.7523 27.5408 15.6283 29.0148C15.9044 29.4793 16.5036 29.6314 16.9667 29.3545C17.4298 29.0776 17.5814 28.4766 17.3054 28.0121C16.6032 26.8306 16.2024 25.4616 16.2024 24C16.2024 19.5829 19.8895 15.9523 24.5 15.9523C25.3505 15.9523 26.1692 16.0761 26.939 16.3054L26.9861 16.3194C27.375 16.4353 27.7371 16.5431 28.0173 16.5967C28.1619 16.6243 28.3589 16.6532 28.5651 16.6352C28.7783 16.6166 29.1264 16.5347 29.3891 16.2157C29.6406 15.9104 29.6678 15.5668 29.647 15.341C29.6276 15.1309 29.5614 14.9426 29.508 14.8098C29.4055 14.5551 29.2364 14.238 29.0598 13.9069L28.4521 12.7675Z"
        fill="#0051FF"
      />
      <path
        d="M33.3717 18.9853C33.0956 18.5208 32.4964 18.3687 32.0333 18.6456C31.5702 18.9225 31.4186 19.5235 31.6946 19.988C32.3968 21.1694 32.7976 22.5384 32.7976 24C32.7976 28.4171 29.1105 32.0477 24.5 32.0477C23.6495 32.0477 22.8308 31.9239 22.061 31.6946L22.0101 31.6795C21.6226 31.5641 21.262 31.4568 20.9826 31.4033C20.8381 31.3757 20.6411 31.3468 20.4349 31.3648C20.2217 31.3833 19.8735 31.4652 19.6108 31.7843C19.3594 32.0896 19.3322 32.4332 19.353 32.659C19.3724 32.8691 19.4386 33.0574 19.492 33.1902C19.5943 33.4448 19.7634 33.7617 19.9399 34.0926L20.5479 35.2325C20.8023 35.7094 21.3938 35.8891 21.8692 35.634C22.1248 35.4969 22.2531 35.2325 22.3578 35L23 33.8995C23.49 33.9697 23.9909 34.006 24.5 34.006C30.1331 34.006 34.75 29.5537 34.75 24C34.75 22.1732 34.2477 20.4593 33.3717 18.9853Z"
        fill="#0051FF"
      />
    </svg>
  );
};

export default CircleReloadIcon;
